// extracted by mini-css-extract-plugin
export var modalFooter = "_tq-0";